import { isDealersShopUri, uriIncludesVertical } from './uriUtils';
import { TYPES } from '../constants/favoritesConstants';

export const getFollowTypeFromUri = (uri = '') =>
    isDealersShopUri(uri) && !uriIncludesVertical(uri) ? TYPES.DEALER : TYPES.SEARCH;
